/**
 * LiveEventsCtrl controller
 * Show all Live events
 */

import { PLATFORM_TYPES } from 'app/core/constants'
import { getName } from 'app/helpers/entity'

// controller mixins
LiveEventsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * LiveEventsCtrl controller
 *
 * @class LiveEventsCtrl
 * @memberof mwApp/liveEvents
 * @see mwApp/liveEvents
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/liveEvents.controller:LiveEventsCtrl
 */
/* @ngInject */
export default function LiveEventsCtrl ($scope, $location, Network, LiveEvent, Extension, UrlPolicy, authSvc) {
  var vm = this
  vm.isFound = true

  vm.onScrollUrlPolicies = UrlPolicy.getPolicies(vm.urlPolicies = [], true)
  vm.getUrlPoliciesForStSelect = function (select) {
    select.open && vm.onScrollUrlPolicies(undefined, { q: select.search })
  }

  vm.platforms = PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }).map(getName) // platforms

  // get token generator id from extension
  const { tokenGeneratorName } = $location.search()

  vm.streamPolicyId = $location.search().streamPolicyId

  // get packages
  // Network.loadAll('?vod=true')
  //   .then(networks => { vm.packages = networks.map(keyValue()) })

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = false

  /**
   * Playback token generator name
   *
   * @memberof mwApp/liveEvents.controller:LiveEventsCtrl
   * @type {String}
   */
  vm.tokenGeneratorName = tokenGeneratorName

  /**
   * Live Events List
   *
   * @memberof mwApp/LiveEvents.controller:LiveEventsCtrl
   * @type {models.LiveEvent[]}
   */
  vm.liveEvents = []

  /**
   * Get Live Events List from backend
   *
   * @memberof mwApp/liveEvents.controller:LiveEventsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getLiveEvents = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }
    // if (tableState.search && tableState.search.predicateObject && tableState.search.predicateObject.$) {
    //   tableState.search.predicateObject['name'] = tableState.search.predicateObject.$
    //   delete tableState.search.predicateObject.$
    // }

    var pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}

    if (vm.streamPolicyId) {
      pObject.streamPolicyId = vm.streamPolicyId
      vm.streamPolicyId = null
    }

    LiveEvent.loadSmart(tableState)
      .then(
        data => {
          vm.liveEvents = data.content
          vm.isFound = !!vm.liveEvents.length

          $scope.loading = false
        }
      )
  }

  vm.onOff = function (le) {
    le._onOff()
  }

  /**
   * Delete Live Event
   *
   * @memberof mwApp/liveEvents.controller:LiveEventsCtrl
   * @param {models.LiveEvent} le
   */
  vm.delete = function (le) {
    le._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }

  vm.labelByUrl = function (name) {
    return PLATFORM_TYPES.find(p => p.value === name).name
  }
}
